import { Box, FormControl, MenuItem, Select } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { forwardRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLoading } from "../../../providers/loadingProvider";
import {
  proposalSelector,
  setColleagues,
  setProposal,
} from "../../../store/proposalSlice";
import { userProposalsSelector } from "../../../store/userSlice";
import { getProposalData } from "../helpers/GifService/applicantService";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
}));
export default function ProposalSelector({ ...rest }) {
  const proposals = useSelector(userProposalsSelector);
  const proposal = useSelector(proposalSelector);
  const [selectedProposal, setselectedProposal] = useState(proposal?.id);
  const loading = useLoading();
  const dispatch = useDispatch();

  const classes = useStyles();
  useEffect(() => {
    if (proposal?.id) {
      setselectedProposal(proposal.id);
      return;
    }
    const lid = loading.addLoading("loading proposal");
    const proposalId = proposals[0].id;
    setselectedProposal(proposalId);
    getProposalData(proposalId).then((newProposal) => {
      dispatch(setColleagues([]));
      dispatch(setProposal(newProposal));
      loading.removeLoading(lid);
    });
  }, [dispatch, loading, proposal?.id, proposals]);

  const proposalChanged = (e) => {
    const lid = loading.addLoading("loading proposal");
    var proposalId = e.target.value;
    getProposalData(proposalId).then((newProposal) => {
      dispatch(setColleagues([]));
      dispatch(setProposal(newProposal));
      loading.removeLoading(lid);
    });
  };

  const Proposals = forwardRef((props, ref) => (
    <FormControl
      {...props}
      ref={ref}
      className={classes.formControl}
      size="small"
    >
      <Select
        value={selectedProposal}
        onChange={proposalChanged}
        id="applicant"
      >
        {proposals &&
          proposals.map((a) => (
            <MenuItem key={a.id} value={a.id}>
              {a.name}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  ));
  const Proposal = forwardRef((props, ref) => (
    <Box {...props} ref={ref} fontSize={18} fontWeight={500}>
      {proposals[0]?.name}
    </Box>
  ));
  return (
    <Box {...rest}>
      {proposals?.length === 1 ? <Proposal /> : <Proposals />}
    </Box>
  );
}
